module.exports = __webpack_public_path__ + "img/ZZRY_2.e76fa19c.jpg";